import { Card } from 'primereact/card';

const StatisticCard: React.FC<{
  title: string;
  value: string | number;
  icon: string;
}> = ({ title, value, icon }) => (
  <Card
    className="bg-black w-full mb-3"
    pt={{
      content: {
        className: 'p-0 m-0',
      },
      root: {
        className: 'p-0 m-0',
      },
    }}
  >
    <div className="flex flex-col gap-x-2">
      <div className="flex justify-between items-center">
        <h4 className="text-[#939393] text-[15.102px] font-normal leading-[normal] tracking-[-0.519px] uppercase">
          {title}
        </h4>
        <div className="h-[20px] w-[20px]">
          <img src={icon} alt={`${title} icon`} />
        </div>
      </div>
      <p className="text-white text-[33.242px] font-bold leading-[normal]">
        {value}
      </p>
    </div>
  </Card>
);

export default StatisticCard;
